(function($) {

	var content = $(".c-sizer__content");

	$(".c-sizer__click").click(function(){

		$(this).next().toggleClass("open");

	});

})(jQuery);
